import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import React from 'react';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { clusteredAlerts, AlertsTypesFilterValues, AlertsDeviceTypesFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeAlertsTypeFilter, onChangeAlertsDeviceFilter } from '../../../ac/onChangeMapFilters';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';
import classnames from 'classnames';

const CombinedAlertsFilterComponent = ({
    onChangeAlertsTypeFilter,
    onChangeAlertsDeviceFilter,
    AlertsTypesStatuses,
    AlertsDeviceStatuses,
}) => (
    <div>
        <div className={styles.legHead}>{t`Тип попытки`}:</div>
        <StandardRadioGroup
            value={String(AlertsTypesStatuses)}
            onChange={onChangeAlertsTypeFilter}
        >
            {/* Alert Type Filter */}
            {AlertsTypesFilterValues.map(({ label, value }) => (
                <FormControlLabel
                    key={value}
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={AlertsTypesStatuses === value}
                            onChange={onChangeAlertsTypeFilter}
                            value={value}
                            className={classnames(styles.isochroneFilterInput, {
                                [styles.checkedIsochroneFilterInput]: AlertsTypesStatuses === value,
                            })}
                            size='small'
                        />
                    }
                    label={t`${label}`}
                    labelPlacement='end'
                />
            ))}
        </StandardRadioGroup>
        <div className={styles.legHead}>{t`Тип девайса`}:</div>
        <StandardRadioGroup
            value={String(AlertsDeviceStatuses)}
            onChange={onChangeAlertsDeviceFilter}
        >
            {AlertsDeviceTypesFilterValues.map(({ label, value }) => (
                <FormControlLabel
                    key={value}
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={AlertsDeviceStatuses === value}
                            onChange={onChangeAlertsDeviceFilter}
                            value={value}
                            className={classnames(styles.isochroneFilterInput, {
                                [styles.checkedIsochroneFilterInput]: AlertsDeviceStatuses === value,
                            })}
                            size='small'
                        />
                    }
                    label={t`${label}`}
                    labelPlacement='end'
                />
            ))}
        </StandardRadioGroup>
    </div>
);
const ClusteredAlertsLegendComponent = () => (
    <div>
        <div className={styles.legHead}>{t`Кластеризированные попытки парковок (концентрация)`}:</div>
        <ColoredItemsLegend
            items={clusteredAlerts.map(({ label, fill }) => ({
                id: fill,
                label: { id: `label_${fill}`, message: i18n._(label) },
                fill,
            }))}
            icon={LEGEND_ICON_TYPES.HEXAGON}
            renderConfig={{
                showIcon: true,
                iconSize: '30px',
                iconOpacity: 0.8,
                fontSize: '0.85rem',
            }}
        />
    </div>
);
const mapStateToProps = ({ mapFilters: { AlertsTypesStatuses, AlertsDeviceStatuses } }) => ({ AlertsTypesStatuses, AlertsDeviceStatuses });
const ConnectedCombinedAlertsFilter = connect(mapStateToProps, { onChangeAlertsTypeFilter, onChangeAlertsDeviceFilter })(CombinedAlertsFilterComponent);

export const ClusteredAlertsCombinedFilter = withDisplayedLayersCheck(ConnectedCombinedAlertsFilter, t`Агрегированные алерты`);
export const ClusteredAlertsLegend = withDisplayedLayersCheck(ClusteredAlertsLegendComponent, t`Агрегированные алерты`);
